import { Form, Input, Modal } from "antd";
import { observer } from "mobx-react-lite";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css

import React, { useState, useEffect } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";
import { IDomEditor, IEditorConfig } from "@wangeditor/editor";
import ProjectStore from "../../../../stores/Admin/ProjectStore";
export interface ApplicationDescribeDialogProps {
  visible: boolean;
  close: () => void;

  projectId?: number;
  appId?: number;
}

const ApplicationDescribeDialog: React.FC<ApplicationDescribeDialogProps> = (
  props
) => {
  const [editor, setEditor] = useState<IDomEditor | null>(null); // 存储 editor 实例
  const [html, setHtml] = useState(""); // 编辑器内容
  const [appKey, setAppKey] = useState("");

  const { details, projects } = ProjectStore;

  useEffect(() => {
    const app = projects
      ?.find((project) => project.id === props.projectId)
      ?.refUrlAppVoList.find((app) => app.id === props.appId);
    setAppKey(app?.key ? app.key : "");
  }, [props.visible, props.appId, props.projectId]);
  useEffect(() => {
    setHtml(details);
  }, [ProjectStore.details]);

  const toolbarConfig = {};
  const editorConfig: Partial<IEditorConfig> = {
    placeholder: "请输入内容...",
    MENU_CONF: {
      uploadImage: {
        base64LimitSize: 2 * 1024 * 1024, // 2MB
      },
    },
  };
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);
  const submit = () => {
    ProjectStore.editDetails(appKey, html);
    props.close();
  };
  return (
    <Modal
      title="填写描述"
      width={1000}
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <div style={{ border: "1px solid #ccc", zIndex: 100 }}>
        <Toolbar
          editor={editor}
          defaultConfig={toolbarConfig}
          mode="default"
          style={{ borderBottom: "1px solid #ccc" }}
        />
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={(editor) => setHtml(editor.getHtml())}
          mode="default"
          style={{ height: "500px" }}
        />
      </div>
      <div style={{ marginTop: "15px" }}>{}</div>
    </Modal>
  );
};

export default observer(ApplicationDescribeDialog);
